/** A map of `<width>x<height>` breakpoint key → landing-page HTML URL. */
export type LandingPageUrls = Record<string, string>;

/**
 * Picks the landing-page URL whose breakpoint best fits the preview width: the
 * largest breakpoint whose width is ≤ the preview width, falling back to the
 * smallest breakpoint when the preview is narrower than all of them. Returns
 * null until a width has been measured, so we don't fetch the wrong breakpoint
 * and immediately refetch.
 */
export function selectLandingPageUrl(
  urls: LandingPageUrls | null | undefined,
  width: number
): string | null {
  if (!urls || width <= 0) return null;

  const breakpoints = Object.entries(urls)
    .map(([key, url]) => ({ width: parseInt(key.split('x')[0], 10), url }))
    .filter((bp) => Number.isFinite(bp.width))
    .sort((a, b) => a.width - b.width);

  if (breakpoints.length === 0) return null;

  let selected = breakpoints[breakpoints.length - 1];
  for (const bp of breakpoints) {
    if (bp.width <= width) selected = bp;
    else break;
  }

  return selected.url;
}
